module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.efb28868.svg";